/**
 * @param {Record<string,string>} assets
 */
function loadAssets(assets) {
	assets["farmcam-sim.png"] = new URL(
		"../assets/luda/farmcam-sim.png",
		import.meta.url,
	).href;
	assets["favicon-16x16.png"] = new URL(
		"../assets/luda/favicon-16x16.png",
		import.meta.url,
	).href;
	assets["favicon-32x32.png"] = new URL(
		"../assets/luda/favicon-32x32.png",
		import.meta.url,
	).href;
	assets["fencealarm.png"] = new URL(
		"../assets/luda/fencealarm.png",
		import.meta.url,
	).href;
	assets["fencealarm2.png"] = new URL(
		"../assets/luda/fencealarm2.png",
		import.meta.url,
	).href;
	assets["logo.png"] = new URL(
		"../assets/luda/logo.png",
		import.meta.url,
	).href;
	assets["smartplug.png"] = new URL(
		"../assets/luda/smartplug.png",
		import.meta.url,
	).href;
	assets["smartplug2.png"] = new URL(
		"../assets/luda/smartplug2.png",
		import.meta.url,
	).href;
}

/**
 * @param {Record<string,string>} assets
 * @param {import("./common").Config} config
 */
export function loadLudaAppEnv(assets, config) {
	loadAssets(assets);
	populateConfig(config);
	import(`../css/luda/style.css`);
}

/**
 * @param {import("./common").Config} config
 */
function populateConfig(config) {
	config.apiBaseUrl = "https://api.luda.farm";
	config.apiHost = "api.luda.farm";
	config.appId = "my.luda.farm";
	config.baseUrl = "https://my.luda.farm";
	config.brand = "luda";
	config.navbarTheme = "is-dark";
	config.sp2gwHost = "smartplug2.luda.farm";
	config.stripeBaseUrl = "https://dashboard.stripe.com";
	config.supportedDevices = [
		"farmcam-sim",
		"fencealarm2",
		"fencealarm",
		"smartplug2",
		"smartplug",
	];
}
